import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Twitter, Mail, MapPin, Shield, Truck, Headphones } from 'lucide-react';
import { platforms } from '../mock/mock';

const Footer = ({ showCTA = true }) => {
  return (
    <footer className="relative bg-[#08080c] border-t border-white/5 pt-16 pb-10">
      {showCTA && (
        <div className="max-w-7xl mx-auto px-5 lg:px-8 mb-16">
          <div className="glass-card rounded-3xl p-8 lg:p-12 bg-gradient-to-br from-[#ff8247]/10 to-[#ff2d6f]/10 border-[#ff8247]/20">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl lg:text-4xl font-bold text-white leading-tight mb-3">
                  Prêt à <span className="gradient-text">exploser</span> ?
                </h3>
                <p className="text-white/60">Commencez votre boost aujourd’hui et voyez la différence en moins de 12h.</p>
              </div>
              <div className="flex flex-wrap items-center gap-3 lg:justify-end">
                <Link to="/collections" className="btn-primary text-sm">Démarrer mon boost</Link>
                <a href="#reviews" className="btn-ghost text-sm">Voir les avis</a>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#ff8247] via-[#ff4d1a] to-[#ff2d6f] flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-[#0a0a0f]" fill="currentColor">
                  <path d="M12 2 3 7v10l9 5 9-5V7l-9-5Zm0 2.3 6.5 3.6L12 11.5 5.5 7.9 12 4.3Zm-7 5.5 6 3.3v6.6l-6-3.3V9.8Zm14 0v6.6l-6 3.3v-6.6l6-3.3Z"/>
                </svg>
              </div>
              <span className="text-white font-bold text-lg">SociBoost</span>
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs mb-6">
              Global Social Media Growth. Real followers, likes and views livrés en 12h dans le monde entier.
            </p>
            <div className="flex gap-2">
              {[Instagram, Facebook, Youtube, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#ff8247] hover:text-[#0a0a0f] text-white flex items-center justify-center transition">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white font-semibold mb-4 text-sm">Réseaux</div>
            <ul className="space-y-2">
              {platforms.slice(0, 6).map(p => (
                <li key={p.id}><Link to={`/collections/${p.slug}`} className="text-white/50 hover:text-[#ff8247] text-sm transition">{p.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4 text-sm">Entreprise</div>
            <ul className="space-y-2">
              <li><a href="#" className="text-white/50 hover:text-[#ff8247] text-sm transition">À propos</a></li>
              <li><a href="#reviews" className="text-white/50 hover:text-[#ff8247] text-sm transition">Avis clients</a></li>
              <li><a href="#faq" className="text-white/50 hover:text-[#ff8247] text-sm transition">FAQ</a></li>
              <li><a href="#" className="text-white/50 hover:text-[#ff8247] text-sm transition">Blog</a></li>
              <li><a href="#" className="text-white/50 hover:text-[#ff8247] text-sm transition">Affiliation</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4 text-sm">Contact</div>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <Mail className="w-4 h-4 mt-0.5 text-[#ff8247]" />
                <span>contact@sociboost.com</span>
              </li>
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <Headphones className="w-4 h-4 mt-0.5 text-[#ff8247]" />
                <span>24/7 · Worldwide Support</span>
              </li>
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-[#ff8247]" />
                <span>Worldwide Delivery</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 py-6 border-y border-white/5 mb-8">
          {[{ i: Shield, t: 'Paiement 100% sécurisé', d: 'Chiffrement SSL 256-bit' },
            { i: Truck, t: 'Fast & Secure Delivery', d: 'Progressive & naturelle · 12h' },
            { i: Headphones, t: 'Worldwide Support', d: 'Disponible 24/7' }].map((f, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#ff8247]/10 flex items-center justify-center"><f.i className="w-5 h-5 text-[#ff8247]" /></div>
              <div>
                <div className="text-white text-sm font-semibold">{f.t}</div>
                <div className="text-white/40 text-xs">{f.d}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 pt-2">
          <div className="text-white/40 text-xs">© 2026 SociBoost. Tous droits réservés.</div>
          <div className="flex flex-wrap items-center gap-6 text-white/40 text-xs">
            <a href="#" className="hover:text-[#ff8247] transition">Mentions légales</a>
            <a href="#" className="hover:text-[#ff8247] transition">CGV</a>
            <a href="#" className="hover:text-[#ff8247] transition">Confidentialité</a>
            <a href="#" className="hover:text-[#ff8247] transition">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
